import React, { useState, useEffect } from 'react';
import FormBlog from './FormBlog';
import { baseAPIURL } from '../../config';

const ListBlogs = () => {
    const [blogs, setBlogs] = useState([]);
    
    const fetchBlogs = async () => {
        try {
            // Make API request (example using fetch)
            const response = await fetch(`${baseAPIURL}admin/blog/getAll`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(FormData),
            });

            if (response.ok) {
                const data = await response.json(); // Parse response to JSON
                setBlogs(data.data);
            } else {
                setBlogs([]);
            }
        } catch (error) {
            console.error('Error:', error);
            alert(error.message);
        }
    };

    // Simulating an API call to fetch blog data
    useEffect(() => {

        fetchBlogs();
    }, []);

    return (
        <>
            <FormBlog />
            <section className="p-relative">
                <div className="container mt-4 mb-4">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <h2 className="text-left mb-4">
                                List of Blogs
                                <div style={{ float: 'right' }}>
                                    +
                                </div>
                                <div style={{ clear: 'both' }}></div>
                            </h2>
                            {blogs.length > 0 ? (
                                <ul className="list-group">
                                    {blogs.map((blog) => (
                                        <li key={blog.id} className="list-group-item">
                                            <h5>{blog.title}</h5>
                                            <p>By {blog.author} on {new Date(blog.createdAt).toLocaleDateString()}</p>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="text-center">Loading blogs...</p>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ListBlogs;
